<template>
  <v-btn
    icon="fa-solid fa-xmark"
    size="small"
    color="card"
    elevation="8"
    class="remove-card"
    @click.stop="removeCard"
  />
</template>

<script>
export default {
  name: 'RemoveCardBtn',
  methods: {
    removeCard() {
      this.$emit('removeCard');
    },
  },
};
</script>

<style scoped>
.remove-card {
  opacity: 0.5;
}

.remove-card:hover {
  opacity: 1;
}
</style>
